import React from 'react';

import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core';
import classnames from 'classnames';
import { useFileUploadCreateOne } from 'requests/resources';

import { IconAvatarBot, IconAvatarLumaBot } from 'icons';

import Avatar from './Avatar';
import UploaderAvatar, { UploaderAvatarProps } from './UploaderAvatar';

const styles = (theme: Theme) =>
  createStyles({
    lumaBotAvatar: {
      backgroundColor: theme.custom.palette.colorAccentPeach,
      fontSize: theme.custom.fontSizes.largeIcon,
    },
  });
export interface UploaderAvatarSettingProps
  extends WithStyles,
    Omit<UploaderAvatarProps, 'classes' | 'onUpload' | 'onChange'> {
  onChange: (avatarId: string) => void;
  isLumaBot?: boolean;
}

const UploaderAvatarSetting: React.FC<UploaderAvatarSettingProps> = ({ onChange, isLumaBot, classes, ...rest }) => {
  const fileUploadCreateOne = useFileUploadCreateOne();

  return (
    <UploaderAvatar
      fallback={
        <Avatar className={classnames({ [classes.lumaBotAvatar]: isLumaBot })}>
          {isLumaBot ? <IconAvatarLumaBot color="inherit" fontSize="inherit" /> : <IconAvatarBot />}
        </Avatar>
      }
      onUpload={(data) =>
        fileUploadCreateOne.mutate(data, {
          onSuccess: (fileUpload) => onChange(fileUpload._id),
        })
      }
      {...rest}
    />
  );
};

export default withStyles(styles)(UploaderAvatarSetting);
